// require("turbolinks").start()
// import "../controllers"
// import "@hotwired/turbo"
import { Turbo } from "@hotwired/turbo-rails" // TODO update gdy będzie Node >=14
Turbo.session.drive = true
// console.log("turbo aktywne:", Turbo)
